import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {EmptyBannerContainerBox} from "./empty-banner-container.box";

export class EmptyBannerComponentProps {
  showPlaceholder: boolean;
  minHeight: string;
}


@observer
export class EmptyBannerComponent extends OrbitComponent<EmptyBannerComponentProps> {

  render() {
    if(this.props.showPlaceholder && !this.services.device.hybrid.isEmbedded) {
        return (<EmptyBannerContainerBox minHeight={this.props.minHeight} className='cy-cms-banner-placeholder'/>)
    }
    return null;
  }
}

